import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Modal from 'components/shared/modal'
import MessageSpaceOwnerForm from 'forms/public/message-space-owner'

const BookViewing = ({ title, toggle, setActiveModal, setSelected, spaces, place, selectedSpace }) => (
  <Modal title={`Message ${title}`} onClose={toggle} >
    <div className="modal-body my-5">
      <MessageSpaceOwnerForm setActiveModal={setActiveModal} selectedSpace={selectedSpace} setSelected={setSelected} spaces={spaces} place={place} />
    </div>
  </Modal>
)

BookViewing.propTypes = {
  toggle: PropTypes.func,
  title: PropTypes.string,
  setSelected: PropTypes.func.isRequired,
  setActiveModal: PropTypes.func.isRequired,
  selectedSpace: PropTypes.object,
  spaces: PropTypes.array,
  place: PropTypes.string,
}

const mapStateToProps = ({ notification }) => ({
  notification,
})

export default connect(mapStateToProps)(BookViewing)
